/* src/app/order/components/transfer-details/transfer-details.style.scss */
nb-card nb-card-body {
  overflow: visible;
}
.transfer-questions-panel nb-card-body {
  padding-left: 16px;
}
.transfer-questions-panel .question.corrective-plans {
  flex-wrap: wrap;
}
.transfer-questions-panel .question.corrective-plans .question-with-answer {
  display: flex;
  flex-wrap: nowrap;
}
.transfer-questions-panel .question.corrective-plans .validation-message {
  flex-basis: 100%;
}
.transfer-questions-panel .question:last-child {
  margin-bottom: 0 !important;
}
.transfer-questions-panel .select-question {
  width: 150px;
}
.transfer-questions-panel .question-green {
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  color: #007d40;
}
.transfer-questions-panel #transfer-reason {
  margin-top: 10px;
}
.transfer-questions-panel .question-text {
  font-size: 15px;
  line-height: 1.47;
  vertical-align: sub;
}
.transfer-questions-panel .answer-part {
  padding-right: 0;
  margin-right: 30px;
  min-width: 140px;
}
.transfer-questions-panel .question-part {
  padding-left: 0;
  display: flex;
  align-items: center;
}
.transfer-questions-panel .margin-bottom-10 {
  margin-bottom: 10px;
}
.transfer-questions-panel .reason-answer {
  margin-top: 10px;
  max-width: 100% !important;
}
.transfer-questions-panel .dates-row {
  display: flex;
}
.transfer-questions-panel .dates-row .last-audit-date {
  width: 100%;
  padding-right: 15px;
}
.transfer-questions-panel .dates-row .expiration-date {
  width: 100%;
  padding-left: 15px;
}
.transfer-questions-panel .nc-row {
  display: flex;
  margin-bottom: 10px;
}
.transfer-questions-panel .nc-row .major-nc {
  width: 100%;
  padding-right: 15px;
}
.transfer-questions-panel .nc-row .minor-nc {
  width: 100%;
  padding-left: 15px;
}
.question {
  margin-bottom: 20px !important;
  flex-wrap: wrap;
}
.question svg-icon {
  position: relative;
  bottom: 6px;
  left: 5px;
}
.question .validation-message {
  margin-top: 0 !important;
}
.toggle-details-section {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  text-align: center;
  color: #007d40;
  position: absolute;
  cursor: pointer;
  top: 34px;
  right: 24px;
  text-decoration: none;
}
.toggle-details-section nb-icon {
  position: relative;
  top: 2px;
}
textarea {
  max-height: 200px !important;
}
.validation-message {
  float: left;
  flex-basis: 100%;
}
nb-radio {
  display: inline-block !important;
}
.audit-date-label-flex {
  display: flex;
}
.audit-date-label-flex .example-label {
  font-family: Arial, sans-serif;
  font-size: 12px;
  line-height: 1.33;
  text-align: right;
  color: #8C8C8C;
  margin-left: auto !important;
  vertical-align: middle;
  text-align: right;
  color: #007d40;
}
@media screen and (max-width: 767px) {
  .transfer-questions-panel .form-row {
    flex-direction: column-reverse;
  }
  .transfer-questions-panel .form-row.question .validation-message {
    margin-left: 0;
    margin-top: 0;
    order: -1;
  }
  .transfer-questions-panel .form-row.question.corrective-plans .question-with-answer {
    flex-direction: column-reverse;
  }
  .transfer-questions-panel .dates-row {
    flex-wrap: wrap;
  }
  .transfer-questions-panel .dates-row .last-audit-date {
    padding-right: 0;
    margin-bottom: 20px;
  }
  .transfer-questions-panel .dates-row .expiration-date {
    padding-left: 0;
  }
  .transfer-questions-panel .nc-row {
    flex-wrap: wrap;
  }
  .transfer-questions-panel .nc-row .major-nc {
    margin-bottom: 10px;
    padding-right: 0;
  }
  .transfer-questions-panel .nc-row .minor-nc {
    padding-left: 0;
  }
  .transfer-questions-panel .select-question {
    width: 100%;
  }
}
/*# sourceMappingURL=transfer-details.style.css.map */
